import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
	selector: 'app-permission-denied-dialog',
	templateUrl: './permission-denied-dialog.component.html',
})
export class PermissionDeniedDialogComponent {
	constructor(
		public dialogRef: MatDialogRef<PermissionDeniedDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: { message: string },
		private readonly router: Router,
	) {}

	closeDialog(): void {
		this.router.navigate(['inicio']);
		this.dialogRef.close();
	}
}
